module.exports = __webpack_public_path__ + "img/icon5.a3d48c8f.svg";